import { getQueryParamsAndQueryString } from '@thoughtspot/env-flags';
import _ from 'lodash';
const getParameterNameParam = (index) => `param${index}`;
const getOverrideValueParam = (index) => `paramVal${index}`;
const MAX_RUNTIME_PARAM_INPUTS = 50;
export function getRuntimeParameterInput(urlSearchParams = getQueryParamsAndQueryString({
    includeSearch: true,
    includeHash: true,
}).queryParams) {
    const START_INDEX = 1;
    const result = [];
    for (let index = START_INDEX; index < MAX_RUNTIME_PARAM_INPUTS; index++) {
        const name = _.get(urlSearchParams, getParameterNameParam(index));
        const value = _.get(urlSearchParams, getOverrideValueParam(index));
        if (name && !_.isNil(value)) {
            result.push({
                parameterName: name,
                overrideValue: value.toString(),
            });
        }
        else {
            break;
        }
    }
    return result;
}
export function getRuntimeParameters(defaultQueryParams) {
    const urlSearchParams = _.mapValues(getQueryParamsAndQueryString({ includeSearch: true, includeHash: true })
        .queryParamsMultiValue, val => (val.length === 1 ? val[0] : val));
    const result = getRuntimeParameterInput();
    if (defaultQueryParams) {
        const resultDefault = getRuntimeParameterInput();
        resultDefault.forEach(param => {
            const matchingParam = result.find(item => item.parameterName === param.parameterName &&
                item.overrideValue === param.overrideValue);
            if (matchingParam) {
                matchingParam.overrideValue = param.overrideValue;
            }
            else {
                result.push(param);
            }
        });
    }
    return result;
}
//# sourceMappingURL=runtime-parameter.util.js.map